import {
  ADDRESS,
  DATE,
  LINK,
  MULTI_LINE,
  SINGLE_LINE,
} from 'ducks/crm/customFields'
import { Input, TextArea } from 'util/ui'
import { useAutofocus } from 'util/hooks'

export default function CustomFieldEditValue({
  customFieldKey,
  customFieldType,
  customFieldValue = {},
}) {
  const { content } = customFieldValue || {}
  const autofocusRef = useAutofocus()
  switch (customFieldType) {
    case ADDRESS:
      return (
        <>
          <Input
            defaultValue={customFieldValue.street}
            fluid
            name={`${customFieldKey}.street`}
            placeholder="Street"
            ref={autofocusRef}
          />
          <Input
            defaultValue={customFieldValue.street2}
            fluid
            name={`${customFieldKey}.street2`}
            placeholder="Street 2"
          />
          <Input
            defaultValue={customFieldValue.city}
            fluid
            name={`${customFieldKey}.city`}
            placeholder="City"
          />
          <Input
            defaultValue={customFieldValue.postalCode}
            fluid
            name={`${customFieldKey}.postalCode`}
            placeholder="Postal code"
          />
          <Input
            defaultValue={customFieldValue.country}
            fluid
            name={`${customFieldKey}.country`}
            placeholder="Country"
          />
        </>
      )
    case DATE:
      return (
        <Input
          defaultValue={content}
          fluid
          name={`${customFieldKey}.content`}
          ref={autofocusRef}
        />
      )
    case LINK:
      return (
        <>
          <Input
            defaultValue={customFieldValue.link}
            fluid
            name={`${customFieldKey}.link`}
            placeholder="URL"
            ref={autofocusRef}
          />
          <Input
            defaultValue={customFieldValue.text}
            fluid
            name={`${customFieldKey}.text`}
            placeholder="Text"
          />
        </>
      )
    case MULTI_LINE:
      return (
        <TextArea
          className="Hello"
          defaultValue={content}
          name={`${customFieldKey}.content`}
          ref={autofocusRef}
        />
      )
    case SINGLE_LINE:
      return (
        <Input
          defaultValue={content}
          fluid
          name={`${customFieldKey}.content`}
          ref={autofocusRef}
        />
      )
    default:
      return null
  }
}
